<template>
  <div class="global-body-style">
    <el-tabs v-model="activeName" class="base-normal-tab-layout">
      <el-tab-pane label="全部提交" name="all" lazy>
        <approve-subscribe-list type="all" v-if="activeName === 'all'" />
      </el-tab-pane>
      <el-tab-pane label="我提交" name="submitMine" lazy>
        <approve-subscribe-list type="submitMine" v-if="activeName === 'submitMine'" />
      </el-tab-pane>
      <el-tab-pane label="我处理" name="approveMine" lazy>
        <approve-subscribe-list type="approveMine" v-if="activeName === 'approveMine'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ApproveSubscribeList from './list';
export default {
  name: 'ApproveSubscribe',
  data () {
    return {
      activeName: 'all',
    }
  },
  components: {
    ApproveSubscribeList
  },
}
</script>
<style lang="less">
@import url('~@/assets/style/base/tab.less');
</style>
